import * as yup from "yup";

export const schema = yup.object({
  email: yup
    .string()
    .matches(/^[\w\-.]+@([\w-]+\.)+[\w-]{2,4}$/g, "Please enter a valid email address")
    .required("Please enter a valid email address"),
  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  rememberMe: yup.boolean(),
});
